import { type DSSurfaceColorType, DSRating, DSText } from '@zoe/ds-web'
import styled from 'styled-components'

import type { FragmentComponent } from '@/types/graphql'

export type RatingRecord = {
  __typename: 'RatingRecord'
  id: string
  rating: number
  label: string
  showRatingValue?: boolean
  surfaceColor?: DSSurfaceColorType
  dataTestId?: string
  padding?: string
}

const fragment = `
  fragment RatingBlockFragment on RatingRecord {
    __typename
    id
    rating
    label
    showRatingValue
    surfaceColor
    dataTestId
    padding
  }
`

// TODO: Replace with inline property in DSSurface - WEB-567
const StyledRatingContainer = styled.div<{ $surfaceColor?: DSSurfaceColorType; $padding?: string }>`
  background-color: ${({ $surfaceColor }) =>
    $surfaceColor ? `var(--color-surface-${$surfaceColor})` : 'var(--color-surface-cream-subtle)'};
  gap: var(--grid-8);
  padding: ${({ $padding }) =>
    $padding !== '' || $padding != undefined ? `var(--grid-${$padding})` : 'var(--grid-12)'};
  border-radius: 100px;
  display: inline-flex;
  align-items: center;
`
export const RatingBlock: FragmentComponent<{}, RatingRecord> = ({ record }) => {
  return (
    <StyledRatingContainer $surfaceColor={record.surfaceColor || 'neutral'} $padding={record.padding}>
      {record.showRatingValue && (
        <DSText variant="fluid-paragraph-200" weight="semiBold" color="primary">
          {record.rating}/5
        </DSText>
      )}

      <DSRating value={record.rating} size={24} />
      {record.label && (
        <DSText as="span" variant="fluid-paragraph-200">
          {record.label}
        </DSText>
      )}
    </StyledRatingContainer>
  )
}

RatingBlock.fragment = fragment
RatingBlock.recordName = 'RatingRecord'
